import React from "react";
import PhenomCaseStudySection from "./PhenomCaseStudy/PhenomCaseStudySection";
import PhenomCaseSection2 from "./PhenomCaseStudy/PhenomCaseSection2";
import PhenomCaseStudySection3 from "./PhenomCaseStudy/PhenomCaseStudySection3";
import PhenomCaseSection4 from "./PhenomCaseStudy/PhenomCaseSection4";
import PhenomCaseSection5 from "./PhenomCaseStudy/PhenomCaseSection5";
import PhenomCaseStudySection6 from "./PhenomCaseStudy/PhenomCaseStudySection6";
import PhenomCaseSection8 from "./PhenomCaseStudy/PhenomCaseSection8";
import PhenomCaseSection7 from "./PhenomCaseStudy/PhenomCaseSection7";
import PhenomCaseStudyHome from "./PhenomCaseStudy/PhenomCaseStudyHome";
import FaqComponent from "../../../Components/Footer/FaqComponent/FaqComponent";
import HelpCard from "../../../Components/Footer/HelpCenterCard/HelpCard";

export default function CaseStudy() {
  return (
    <div className="space-y-8 lg:space-y-16 mx-auto">
      <div>
        <PhenomCaseStudyHome />
      </div>
      <div>
        <PhenomCaseStudySection />
      </div>

      <div>
        <PhenomCaseSection2 />
      </div>

      <div>
        <PhenomCaseStudySection3 />
      </div>

      <div>
        <PhenomCaseSection4 />
      </div>

      <div>
        <PhenomCaseSection5 />
      </div>

      <div>
        <PhenomCaseStudySection6 />
      </div>

      <div>
        <PhenomCaseSection7 />
      </div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0 help_card">
        <HelpCard />
      </div>

      {/* <div >
                <PhenomCaseSection8/>
            </div> */}
    </div>
  );
}
